<template>
    <transition name="slide-fade">
        <div class="my-callback" v-if="isOpen">
            <div class="callback__wrapper">
                <div class="visual-canvas"
                     style="width: 100%;
                        height: 100%;">
                    <svg :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
                         preserveAspectRatio="xMidYMid
                         slice"
                         class="visual-canvas__svg">
                        <image x="0" y="0" width="100%" height="100%"
                               xlink:href="/images/evpatoria.jpg"></image>
                        <rect width="100%" height="100%"
                              fill-opacity="0.6"
                              mask="url(#visual-canvas__hole)"
                              class="visual-canvas__overlay"></rect>
                        <path id="1"
                              v-for="element in render.elements" :key="element.id"
                              :link=element.link
                              :d=element.path
                              @click="selected.includes(+element.id) ? selected.splice(selected.indexOf(+element.id), 1)
                                : selected.push(+element.id)"
                              :class="['visual-canvas__path', {'is-active': selected.includes(+element.id)}]">
                        </path>
                        <defs>
                            <mask id="visual-canvas__hole">
                                <rect fill="white" width="100%" height="100%"></rect>
                                <path v-for="element in render.elements"
                                      :key="element.id"
                                      :d=element.path>
                                </path>
                            </mask>
                        </defs>
                    </svg>
                    <div class="close_theme_genplan" @click="closeOpen">
                        <button class="button-close" aria-label="Закрыть генплан">
                            <svg viewBox="0 0 11 11">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M5.32262 6.949L1.83262 10.439C1.49311 10.7785
                            0.853809 10.6897 0.404706 10.2406C-0.0443966 9.79146
                            -0.133238 9.15216 0.206274 8.81265L3.69627
                            5.32265L0.206279 1.83266C-0.133233 1.49315
                            -0.0443917 0.853849 0.404711 0.404746C0.853814
                            -0.0443571 1.49311 -0.133198 1.83262 0.206314L5.32262
                            3.69631L8.81265 0.206275C9.15216 -0.133238
                            9.79146 -0.0443967 10.2406 0.404706C10.6897 0.853809 10.7785 1.49311 10.439 1.83262L6.94896
                            5.32265L10.439 8.81269C10.7785 9.1522 10.6897 9.7915 10.2406 10.2406C9.79146 10.6897 9.15216
                            10.7785 8.81265 10.439L5.32262 6.949Z"/>
                            </svg>
                        </button>
                    </div>

                    <transition name="slide-fade">
                        <button @click="selectBuilding()"
                                type="button"
                                class="button button_theme_color button_theme_genplan button_theme_content-width">
                            <span>{{submitButton}}</span>
                        </button>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';


export default {
    data() {
        return {
            isOpen   : false,
            selected : [],
            selected2: []
        };
    },
    methods: {
        ...mapActions(['changeSelected']),

        openModal() {
            this.isOpen = true;
        },
        closeOpen() {
            this.isOpen = false;
        },
        selectBuilding() {
            this.$emit('sendBuilding');
            this.closeOpen();
        }
    },
    computed: {
        ...mapGetters({
            renderSize       : 'GET_CANVAS_SIZE',
            selectedBuildings: 'GET_SELECTED_BUILDINGS',
            render           : 'GET_RENDER'
        }),
        submitButton() {
            // скрываем на время
            // const corpuses = this.selected.join(',');

            if (this.selected.length > 1) {
                return `Выбрать корпуса`;
            } else if (!this.selected.length) {
                return 'Применить';
            }

            return `Выбрать корпус`;
        }
    },
    watch: {
        selectedBuildings() {
            this.selected = this.selectedBuildings;
        }
    }
};
</script>


<style>
    .slide-fade-enter-active {
        transition: all 0.3s cubic-bezier(1, 0.8, 0.5, 1);
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter {
        transform: translateX(50px);
        opacity: 0;
    }

    .slide-fade-leave-to {
        transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
        opacity: 0;
    }

    .my-callback {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 1000;
        background-color: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .close_theme_genplan {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .button-close {
        background-color: #ee7623;
    }

    .visual-canvas {
        position: relative;
    }

    .visual-canvas__svg {
        width: 100%;
        height: 100%;
    }

    .visual-canvas__overlay {
        @include transition(fill-opacity);
    }

    .visual-canvas__path {
        transition: 0.3s;
        fill: #30261d;
        stroke: white;
        stroke-width: 5px;
        fill-opacity: 0.05;
        stroke-opacity: 0;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }

    .visual-canvas__path.is-active {
        stroke: #78c05f;
        stroke-width: 10px;
        stroke-opacity: 1;
    }

    .visual-canvas__path:hover {
        stroke-opacity: 1;
        fill-opacity: 0;
    }

    .button_theme_genplan {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translateX(-50%);
    }

    .multiselect__tags {
        padding: 8px 40px 0 18px;
    }
</style>
